"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPaymentLinkCount = void 0;
var getPaymentLinkCount = function (instance) { return function (config) {
    return instance.get("/catalogues/baskets/payment-links/count", config);
}; };
exports.getPaymentLinkCount = getPaymentLinkCount;
